import { useAppSelector } from "redux/hooks";
import { useNavigate, useParams } from "react-router-dom";
import CircleLoader from "components/atoms/CircleLoader";
import AddPickerForm from "./AddPickerForm";
import UpdatePickerForm from "./UpdatePickerForm";
import PickerService from "services/picker.service";

export default function AddPicker() {
  const { id } = useParams();
  const navigate = useNavigate();
  const loading = useAppSelector((state) => state.formLoader.loading);

  const handleSubmit = async (values: any) => {
    let data = { ...values };

    if (id) PickerService.updatePicker(`${id}`, data, navigate);
    else PickerService.addPicker(data, navigate);
  };

  return (
    <div>
      <div className="form">
        {loading && <CircleLoader />}

        <AddPickerForm onSubmit={handleSubmit} />

        {id && <UpdatePickerForm id={id} />}
      </div>
    </div>
  );
}
